import axios from 'axios';
import {base_api} from './base';

export function getLeadForms(includeDeleted) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/LeadForms?includeDeleted=${includeDeleted}`, {headers});
}

export function getLeadsProcessed(includeDeleted, companyId, eventId) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  let api = '';
  if (companyId) {
    api = `/LeadForms/GetLeadsProcessed?includeDeleted=${includeDeleted}&companyId=${companyId}&eventId=${eventId}`;
  } else {
    api = `/LeadForms/GetLeadsProcessed?includeDeleted=${includeDeleted}&eventId=${eventId}`;
  }
  return axios.get(`${base_api + api}`, {headers});
}

export function getLeadFormById(id) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/LeadForms/GetLeadFormById?id=${id}`, {headers});
}

export function exportLeadFile(companyId, eventId) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  let route = `/LeadForms/ExportLeadFile?companyId=${companyId}&eventId=${eventId}`;
  return axios.get(`${base_api}` + route, {headers});
}

export function sendEmail(data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.post(`${base_api}/LeadForms/sendEmail`, data, {headers});
}

export function addLeadForm(data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.post(`${base_api}/LeadForms/AddLeadForm`, data, {headers});
}

export function addLeadFormList(data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.post(`${base_api}/LeadForms/AddLeadFormList`, data, {headers});
}

export function updateLeadForm(leadFormId, data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.put(`${base_api}/LeadForms/UpdateLeadForm?leadFormId=${leadFormId}`, data, {headers});
}

export function updateLeadFormList(leadFormIds, data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.put(`${base_api}/LeadForms/UpdateLeadFormList?leadFormIds=${leadFormIds}`, data, {headers});
}

export function deleteLeadForm(id, hardDelete) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.delete(`${base_api}/LeadForms/DeleteLeadForm?id=${id}&hardDelete=${hardDelete}`, {headers});
}

export function deleteLeadFormList(ids, hardDelete) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.delete(`${base_api}/LeadForms/DeleteLeadFormList?ids=${ids}&hardDelete=${hardDelete}`, {headers});
}



// WEBPACK FOOTER //
// ./src/services/LeadForms.service.js